
import React, { useState, useEffect } from 'react';
import { useAIChat } from '@/hooks/useAIChat';
import ChatHeader from './ChatHeader';
import ChatMessageList from './ChatMessageList';
import ChatInput from './ChatInput';
import ChatFooter from './ChatFooter';

interface AIModalProps {
  onClose: () => void;
}

const AIModal: React.FC<AIModalProps> = ({ onClose }) => {
  const { messages, sendMessage, isLoading, popularQuestions } = useAIChat();
  const [showSuggestions, setShowSuggestions] = useState(true);
  const [autoScroll, setAutoScroll] = useState(true);

  const handleSendMessage = (input: string) => {
    sendMessage(input);
    setShowSuggestions(false);
    setAutoScroll(true);
  };

  const handleSuggestedQuestion = (question: string) => {
    sendMessage(question);
    setShowSuggestions(false);
    setAutoScroll(true);
  };

  useEffect(() => {
    if (messages.length > 0) {
      setShowSuggestions(false);
    }
  }, [messages]);

  return (
    <div className="fixed bottom-20 right-4 w-96 bg-white/80 shadow-2xl rounded-xl z-50 flex flex-col backdrop-blur-lg">
      <ChatHeader onClose={onClose} />
      
      <ChatMessageList 
        messages={messages}
        isLoading={isLoading}
        showSuggestions={showSuggestions}
        handleSuggestedQuestion={handleSuggestedQuestion}
        autoScroll={autoScroll}
        setAutoScroll={setAutoScroll}
        popularQuestions={popularQuestions}
      />
      
      <ChatInput 
        onSendMessage={handleSendMessage}
        isLoading={isLoading}
      />
      
      <ChatFooter />
    </div>
  );
};

export default AIModal;
